import React from 'react';
import PropTypes from 'prop-types';

import { getLabel } from '../utils';
import cn from 'classnames';

const Select = ({
  name,
  label,
  options,
  defaultValue,
  value,
  onChange,
  required,
  error,
  disabled,
  helperText,
  styles,
  formGroupProps,
  onFocus,
  onBlur,
}) => {
  return (
    <div
      className={cn('form-group', formGroupProps?.className)}
      style={formGroupProps?.style}
    >
      {label && (
        <label
          htmlFor={name}
          style={{
            ...(styles.label || {}),
            ...(error ? { color: 'red' } : {}),
          }}
        >
          {getLabel(label, required)}
        </label>
      )}
      <div className="select-custom">
        <select
          name={name}
          id={name}
          className="form-control"
          defaultValue={defaultValue}
          value={value}
          onChange={onChange}
          disabled={disabled}
          onFocus={onFocus}
          onBlur={onBlur}
          style={{
            ...(error ? { borderColor: 'red' } : {}),
          }}
        >
          {options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              hidden={option.hidden}
            >
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {helperText && (
        <p
          style={{
            ...(error ? { color: 'red' } : {}),
          }}
          className="tw-mb-0"
        >
          {helperText}
        </p>
      )}
    </div>
  );
};

Select.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
      hidden: PropTypes.bool,
    }),
  ),
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  helperText: PropTypes.string,
  styles: PropTypes.shape({
    label: PropTypes.object,
  }),
  formGroupProps: PropTypes.shape({
    className: PropTypes.string,
    style: PropTypes.object,
  }),
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};

Select.defaultProps = {
  styles: {},
};

export default Select;
